import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("vvs_admin_token");
    if (token && config.url?.includes("/admin/")) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const fileUrl = (path) => (path?.startsWith("http") ? path : `${API}/files/${path}`);
